"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.red = void 0;
exports.red = {
    c10: '#510609',
    c20: '#790C14',
    c30: '#A4151E',
    c40: '#D01E29',
    c50: '#F02532',
    c60: '#F75B60',
    c70: '#FF888B',
    c80: '#FAC8C9',
    c90: '#FEECED',
    c100: '#FFFFFF',
};
//# sourceMappingURL=red.js.map